var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilebg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 519,
    viewBox: "0 0 375 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -137.187,
    y: 189.578,
    width: 472.739,
    height: 464.84,
    rx: 151.5,
    transform: "rotate(-45 -137.187 189.578)",
    stroke: "#EEF2E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -137.187,
    y: 144.984,
    width: 472.739,
    height: 464.84,
    rx: 151.5,
    transform: "rotate(-45 -137.187 144.984)",
    stroke: "#EEF2E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -137.894,
    y: 95.9841,
    width: 473.739,
    height: 465.84,
    rx: 152,
    transform: "rotate(-45 -137.894 95.9841)",
    fill: "#E1F6F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilebg);
export default __webpack_public_path__ + "static/media/profilebg.143f8b8207d8d41ee9b145fa3e2081bf.svg";
export { ForwardRef as ReactComponent };